import React, { Component } from "react";
import DefaultFieldsFilter from "./DefaultFields";
import CustomFieldsFilter from "./CustomFields";
import { Tabs } from "@adrianoferreira/wp-react-admin";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";

export const EditUser = (props) => {

	return(
		<div id="poststuff" className="display-data-box">
			<div id="slugdiv" className="postbox">
				<h2 className="hndle ui-sortable-handle"><span>Edit User</span></h2>
				<div className="inside" style={{display: 'block'}}>

					<p>Use this action if you want to edit a post through this particular endpoint, as well as attached taxonomies and custom fields</p>

					{props.endpoint.editUsers.map(
						(el, index) =>

							<FieldGroupContext.Provider key={index} value={{
								action: 'editUsers',
								currentItem: index,
								endpointId: props.id,
								endpoint: props.endpoint
							}}>

								<Tabs tabs={[
									{
										name:    'defaultFields',
										title:   'Default Fields',
										content: <DefaultFieldsFilter group={'defaultFields'} key={index + '-defaultFields'}/>
									},
									{
										name: 'customFields',
										title: 'Custom Fields',
										content: <CustomFieldsFilter key={index + '-customFields'} group={'customFields'}/>
									}
								]} />

							</FieldGroupContext.Provider>
					)}

				</div>
			</div>
		</div>
	)
};

export default EditUser;
